<app-select-multiple 
    [(ngModel)]="values"
    [label]="label"
    [options]="options"
    [loading]="loading"
    [id]="id"
    #selectMultiple
></app-select-multiple>